import { render, staticRenderFns } from "./RewardCard.vue?vue&type=template&id=5dc898d0&scoped=true"
import script from "./RewardCard.vue?vue&type=script&lang=js"
export * from "./RewardCard.vue?vue&type=script&lang=js"
import style0 from "./RewardCard.vue?vue&type=style&index=0&id=5dc898d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc898d0",
  null
  
)

export default component.exports